var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.uploadImgLoading),expression:"uploadImgLoading"}],staticClass:"editor_container"},[_c('div',{attrs:{"id":_vm.customDivId}},[_c('script',{style:(_vm.styleConfig),attrs:{"id":_vm.customId,"name":"content","type":"text/plain"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }